import { render, staticRenderFns } from "./ProductsTableList.vue?vue&type=template&id=60c80f37&"
import script from "./ProductsTableList.vue?vue&type=script&lang=js&"
export * from "./ProductsTableList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports